import React, { useEffect, useState } from 'react'
import {ClipLoader} from "react-spinners/";
import Button from 'react-bootstrap/Button';
import "./ProspectosIngreso.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import { APIToken } from '../../services/ApiOnboarding';
import {useLocation} from 'react-router-dom';
import { Personas2 } from '../../objects/testObjects';
import { ingresoFirma } from '../../objects/objectToken';
import { useIsMobile } from '../../hooks/useIsMobile';

export const ProspectosIngreso = () => {
  const [msg, setMsg] = useState('Para avanzar en el proceso de asociación a Medicus vamos a requerir:')
  const location = useLocation();
  useEffect(() => {
    //get all de url params
    const queryParams = new URLSearchParams(location.search);
    //asign de param key to object objectToken
    ingresoFirma.token = queryParams.get('token') ?? "";
    ingresoFirma.origen = queryParams.get('origen') ?? "";
    setMsg(ingresoFirma?.origen === 'BN' 
    ? 'Para avanzar en el proceso vamos a requerir:' 
    : 'Para avanzar en el proceso de asociación a Medicus vamos a requerir:');
    //asign de param key to object Persona2
    Personas2.firmantes[0].nombre = queryParams.get('nombre') ?? "";
    Personas2.firmantes[0].apellido = queryParams.get('apellido') ?? "";
    Personas2.firmantes[0].dni = queryParams.get('dni') ?? "";
    Personas2.firmantes[0].sexo = queryParams.get('sexo') ?? "";
  }, [location.search]);
  
  
  const [load, setLoading] = useState(false);
  const getUrl = () =>{
    const APIurl = APIToken;
    setLoading(true);
    APIurl.getUrl()
      .then(res => {
        setLoading(false);
        if (ingresoFirma.token === "") {
          window.open(res.data.url);
          window.location.href = res.data.url;
        } else {
          window.location.href = res.data.data.url;
          window.open(res.data.data.url);
        }
    }).catch((error) => { 
        setLoading(false); 
        console.log("ERROR", error);
        error.response.status === 404 
        ? window.open("#/token-vencido", "_self")
        : window.open("#/error-comunicacion", "_self")
    });
  }

  const isMobile = useIsMobile(600);

  return (
    <>
    {isMobile ? 
    (<div className='info-container-img'>
          <img src='Images/logo-azul.png' alt='Logo Medicus 50' />
    </div>) :
    (<div className='info-container-img'>
          {/* <img src='Images/headerResponsive.png' alt='Logo Medicus 50'></img> */}
    </div>)
    }
    <div className="info-container">
        <h3>
            <strong>
            Hola, <br />
            {msg}
            </strong>
        </h3>
        <ol type='a'>
            <li>Que confirmes algunos datos personales.</li>
            {ingresoFirma?.origen !== 'BN' && <li>Que valides tu identidad.</li>}
            <li>Que leas atentamente la documentación y luego firmes en forma online.</li>
        </ol>
          
        {/* <Link to="/ingreso-prospectos" className="link"> */}
        { load && <p className='info-parrafo'> Generando archivos para firmar. Esto puede demorar </p> } 
        <div className="link">
          <Button className="button" onClick={getUrl} disabled={load}>
            {/* <strong>CONTINUAR</strong> */}

            { !load && <strong>CONTINUAR</strong> }
            {  load && <ClipLoader color={"white"} loading={load} size={25} />} 
            {/* {  load && <FontAwesomeIcon className='fas fa-spin fa-fw loader fa-duotone' icon={faSpinnerthird} />}  */}
          </Button>
        </div>
        {/* </Link> */}
    </div>
    </>
  );
}

